export enum ButtonColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Light = 'light',
  Pill = 'pill',
}

export default ButtonColor;
